<template>
  <div :class="{ 'history-box': isDevicePage }">
    <div class="search-bar-margin-bottom-cla">
      <el-form
        style="display:flex;margin-top:5px"
        :inline="true"
        :model="params"
        class="demo-form-inline"
      >
        <el-form-item>
          <el-date-picker
            class="pickData_cla"
            clearable
            v-model="timePick"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            :start-placeholder="$t('common.startTime')"
            :end-placeholder="$t('common.endTime')"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-select clearable v-model="params.source" placeholder="操作来源">
            <el-option
              :label="$t('device.serviceUpdate')"
              value="0"
            ></el-option>
            <el-option
              :label="$t('device.clientUpdate')"
              value="1"
            ></el-option>
            <el-option :label="$t('device.dbsUpdate')" value="2"> </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-select clearable v-model="params.status" placeholder="升级状态">
            <el-option :label="$t('device.upgrading')" value="0"></el-option>
            <el-option
              :label="$t('device.upgradeSuccess')"
              :value="1"
            ></el-option>
            <el-option :label="$t('device.upgradeError')" value="2">
            </el-option>
            <el-option :label="$t('device.downloading')" value="3">
            </el-option>
            <el-option :label="$t('device.fire')" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="!isDevicePage" prop="devSn">
          <el-input
            clearable
            v-model.trim="params.sn"
            :placeholder="$t('device.sn')"
          ></el-input>
        </el-form-item>

        <el-button type="primary" @click="searchFn" icon="el-icon-search">{{
          $t('common.search')
        }}</el-button>
      </el-form>
    </div>
    <div class="black_panel_cla">
      <el-table
        ref="multipleTable"
        :data="tableData"
        style="width: 100%"
        :highlight-current-row="true"
      >
        <el-table-column prop="lastVersion" :label="$t('device.lastVersion')">
        </el-table-column>
        <el-table-column
          prop="currentVersion"
          :label="$t('device.currentVersion')"
        >
        </el-table-column>
        <el-table-column
          prop="createTimestamp"
          :label="$t('common.createdDate')"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTimestamp | dataFormat }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="sn" :label="$t('device.sn')">
        </el-table-column>

        <el-table-column prop="source" :label="$t('device.source')">
          <template slot-scope="scope">
            <span v-if="scope.row.source === 0"
              >{{ $t('device.serviceUpdate') }}
            </span>
            <span v-else-if="scope.row.source === 1">{{
              $t('device.clientUpdate')
            }}</span>
            <span v-else-if="scope.row.source === 2">{{
              $t('device.dbsUpdate')
            }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="status" :label="$t('common.status')">
          <template slot-scope="scope">
            <div style="color:#909399" v-if="scope.row.status === 0">
              {{ $t('device.upgrading') }}
            </div>
            <div style="color: #4db22f" v-if="scope.row.status === 1">
              {{ $t('device.upgradeSuccess') }}
            </div>
            <div style="color:#f56c6c" v-if="scope.row.status === 2">
              {{ $t('device.upgradeError') }}
            </div>
            <div style="color:#05203B" v-if="scope.row.status === 3">
              {{ $t('device.downloading') }}
            </div>
            <div style="color:#05203B" v-if="scope.row.status === 4">
              {{ $t('device.fire') }}
            </div>
            <div style="color:#f56c6c" v-if="scope.row.status === 5">
              {{ $t('device.upgradeTimeout') }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="type" :label="this.$t('common.action')">
          <template slot-scope="scope">
            <span class="btn-text-cla" @click.stop="showDetails(scope.row)">
              {{ $t('common.details') }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:15px">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          :total="pager.total"
          layout="total, prev, pager, next, sizes, jumper"
        ></el-pagination>
      </div>

      <el-dialog
        :append-to-body="true"
        width="50%"
        :title="$t('device.updateDetails')"
        @close="closeDetails"
        :visible.sync="detailsDialog"
        @closed="closedDetails"
      >
        <div class="dia-info-cla">
          <div style="text-align:center">
            <img src="@/assets/zip-icon.png" />
            <div style="margin-top:10px">
              {{ currentRow.lastVersion }}
            </div>
          </div>
          <div style="text-align:center">
            <img src="@/assets/zip-icon1.png" />
            <div style="margin-top:10px">
                {{ currentRow.currentVersion }}
            </div>
          </div>
        </div>
        <div v-if="report.length === 4" class="report-box">
          <div
            :class="{
              'unActive-cla': report[0].resultCode === '',
              'actvie-cla': report[0].resultCode === '0',
              'error-cla':
                report[0].resultCode !== '' && report[0].resultCode !== '0'
            }"
            class="report-item1"
          >
            <div class="circle-box">
              <i class=" check-icon-cla el-icon-circle-check"></i>
              <div class="report-msg-cla">
                <div>{{ report[0].description }}</div>
                <div>{{ report[0].completionTimestamp | dataFormat }}</div>
              </div>
            </div>
          </div>
          <div
            :class="{
              'unActive-cla': report[1].resultCode === '',
              'actvie-cla': report[1].resultCode === '0',
              'error-cla':
                report[1].resultCode !== '' && report[1].resultCode !== '0'
            }"
            class="report-item2"
          >
            <div class="circle-box">
              <div v-if="report[1].resultCode === '0'">
                <el-progress
                  width="18"
                  stroke-width="1"
                  color="#4db22f"
                  type="circle"
                  :show-text="false"
                  :percentage="report[1].percent"
                >
                </el-progress>
                <i class="check-icon el-icon-check"></i>
              </div>
              <i v-else class="check-icon-cla el-icon-circle-check"></i>
              <div class="report-msg-cla">
                <div>{{ report[1].description }}</div>
                <div>{{ report[1].completionTimestamp | dataFormat }}</div>
              </div>
            </div>
          </div>
          <div
            :class="{
              'unActive-cla': report[2].resultCode === '',
              'actvie-cla': report[2].resultCode === '0',
              'error-cla':
                report[2].resultCode !== '' && report[2].resultCode !== '0'
            }"
            class="report-item3"
          >
            <div class="circle-box">
              <i class=" check-icon-cla el-icon-circle-check"></i>
              <div class="report-msg-cla">
                <div>{{ report[2].description }}</div>
                <div>{{ report[2].completionTimestamp | dataFormat }}</div>
              </div>
            </div>
          </div>
          <div
            :class="{
              'unActive-cla': report[3].resultCode === '',
              'actvie-cla': report[3].resultCode === '0',
              'error-cla':
                report[3].resultCode !== '' && report[3].resultCode !== '0'
            }"
            class="report-item4"
          >
            <div class="circle-box">
              <i class="check-icon-cla el-icon-circle-check"></i>
              <div class="report-msg-cla">
                <div>{{ report[3].description }}</div>
                <div>{{ report[3].completionTimestamp | dataFormat }}</div>
              </div>
            </div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="detailsDialog = false">{{
            $t('common.confirm')
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { queryUpgradeHistory, upgradeProgress } from '@/services/deviceApi.js'
import { getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import pickerOptions from '@/utils/pickerOptions.js'
export default {
  data() {
    return {
      tableData: [],
      detailsDialog: false,
      timePick: getCurrentDateStartAndEndTime(),
      pickerOptions: pickerOptions(this),
      params: {
        sn: '',
        status: '',
        source: ''
      },
      currentRow: {},
      report: [],
      isInterval: ''
    }
  },
  props: {
    devSn: {
      type: String,
      default: ''
    },
    isDevicePage: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    devSn: {
      handler: function(val) {
        this.params.sn = val
        this.getHistoryList()
      },
      immediate: true
    }
  },
  methods: {
    closeDetails() {
      if (this.isInterval) {
        clearInterval(this.isInterval)
      }
    },
    showDetails(row) {
      this.currentRow = row
      this.upgradeProgress(true)
      this.isInterval = setInterval(() => {
        this.upgradeProgress(false)
      }, 2500)
    },
    upgradeProgress(isInterval) {
      upgradeProgress({
        sn: this.currentRow.sn,
        taskId: this.currentRow.taskId
      })
        .then(data => {
          if (data.code === '00000000') {
            this.report = data.payload.params.report
            if (isInterval) {
              this.detailsDialog = true
            }
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage(data)
        })
    },
    getHistoryList() {
      let params = Object.assign({}, this.params)
      if (this.timePick !== null && this.timePick.length === 2) {
        params.beginTime = this.timePick[0].getTime()
        params.endTime = this.timePick[1].getTime()
      }
      if (this.devSn) {
        params.sn = this.devSn
      }
      queryUpgradeHistory({
        params: params,
        pager: this.pager
      })
        .then(data => {
          if (data.code) {
            this.tableData = data.payload.results
            this.pager.total = data.payload.totalRecords
            this.pager.pageSize = data.payload.pageSize
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e)
        })
    },
    changePage(current) {
      this.pager.curPage = current
      this.getHistoryList()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.getHistoryList()
    },
    searchFn() {
      this.pager.curPage = 1
      this.getHistoryList()
    }
  }
}
</script>

<style scoped lang="less">
.history-box {
  background-color: #ffffff;
}
.report-box {
  display: flex;
  width: 100%;
  padding: 50px;
  margin-bottom: 60px;
  box-sizing: border-box;
  .report-item {
    position: relative;
    height: 10px;
    background-color: #ebeff5;
  }
  .report-item1 {
    width: 2px;
    .report-item;
  }
  .report-item2,
  .report-item3,
  .report-item4 {
    flex-grow: 1;
    .report-item;
  }
  .circle-box {
    position: absolute;
    right: -10px;
    top: -5px;
    z-index: 1000;
    background: #ffffff;
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }
  .check-icon {
    position: absolute;
    right: 4px;
    top: 4px;
    font-size: 12px;
    font-weight: 600;
  }
  .report-msg-cla {
    position: absolute;
    left: -45px;
    top: 30px;
    width: 90px;
    text-align: center;
  }

  .unactive-cla {
    background-color: #ebeff5;
    .check-icon-cla {
      color: #ebeff5;
    }
  }
  .actvie-cla {
    background-color: #4db22f;
    .check-icon,
    .check-icon-cla {
      color: #4db22f;
    }
  }
  .error-cla {
    background-color: red;
    .check-icon-cla {
      color: red;
    }
  }
  .check-icon-cla {
    font-size: 20px;
  }
}
.dia-info-cla {
  display: flex;
  height: 100px;
  justify-content: space-around;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/updateHistory.vue